export const rulesContent = {
  title: 'Regras e ações da IA',
  description:
    'Defina a autonomia da IA e quais ferramentas do Kraftchat ela poderá usar durante o atendimento.',
  emptyAgentTitle: 'Configure um agente antes de criar regras.',
  emptyAgentDescription:
    'As regras são vinculadas a um agente IA. Vá até Configuração e crie o agente primeiro.',
  agentLabel: 'Agente IA',
  agentPlaceholder: 'Selecione um agente',
  configureLabel: 'Configurar',
  closeLabel: 'Fechar',
  saveLabel: 'Salvar regras',
  savingLabel: 'Salvando...',
  saveSuccess: 'Regras da IA salvas com sucesso.',
  saveError: 'Não foi possível salvar as regras da IA.',
  loadError: 'Não foi possível carregar as regras da IA.',
  loadingLabel: 'Carregando regras da IA...',
  autonomyTitle: 'Autonomia da IA',
  autonomyDescription:
    'Controle se a IA apenas sugere, responde e organiza, ou também executa ações permitidas.',
  autonomyLabel: 'Nível de autonomia',
  autoReplyLabel: 'Permitir respostas automáticas',
  autoReplyDescription:
    'Quando desativado, a IA atua apenas como apoio interno para o atendente.',
  handoffTitle: 'Transferência para humano',
  handoffDescription:
    'Configure quando a IA deve parar, explicar a situação e chamar uma pessoa.',
  handoffEnabledLabel: 'Ativar transferência para humano',
  handoffEnabledDescription:
    'Recomendado para baixa confiança, assuntos sensíveis ou quando o cliente pedir humano.',
  handoffMessageLabel: 'Mensagem de transferência',
  handoffMessagePlaceholder:
    'Ex: Vou chamar um atendente para te ajudar melhor.',
  handoffTimeoutEnabledLabel:
    'Retomar IA automaticamente após inatividade do atendimento humano',
  handoffTimeoutEnabledDescription:
    'Se nenhum atendente responder publicamente dentro do tempo definido, a IA volta a responder sozinha. O contador reinicia a cada resposta pública de um atendente.',
  handoffTimeoutLabel: 'Tempo de inatividade',
  triggersTitle: 'Gatilhos de transferência',
  triggersDescription:
    'Defina quais situações obrigam a IA a chamar um atendente humano.',
  toolsTitle: 'Ferramentas permitidas',
  toolsDescription:
    'Escolha quais recursos nativos do Kraftchat a IA poderá usar para adiantar o fluxo.',
  safetyTitle: 'Limites de segurança',
  safetyDescription:
    'Use travas para evitar que a IA execute ações sensíveis sem validação humana.',
};

export const autonomyOptions = [
  {
    value: 'suggest_only',
    label: 'Somente sugerir',
    description:
      'A IA ajuda o atendente com sugestões, mas não responde clientes sozinha.',
  },
  {
    value: 'respond_and_organize',
    label: 'Responder e organizar',
    description:
      'A IA responde clientes e pode organizar conversas com ações simples permitidas.',
  },
  {
    value: 'respond_and_execute',
    label: 'Responder e executar ações',
    description:
      'A IA pode responder e executar ações permitidas, como macros, automações e integrações.',
  },
];

export const handoffTriggerOptions = [
  {
    key: 'low_confidence',
    title: 'Baixa confiança',
    description: 'Quando a IA não tiver segurança suficiente para responder.',
  },
  {
    key: 'customer_requested_human',
    title: 'Cliente pediu humano',
    description: 'Quando o cliente solicitar atendimento com uma pessoa.',
  },
  {
    key: 'billing_issue',
    title: 'Cobrança ou pagamento',
    description: 'Dúvidas financeiras devem ser tratadas com mais cautela.',
  },
  {
    key: 'cancellation_request',
    title: 'Cancelamento',
    description: 'Pedidos de cancelamento devem escalar para humano.',
  },
  {
    key: 'sensitive_subject',
    title: 'Assunto sensível',
    description: 'Dados sensíveis, reclamações graves ou risco jurídico.',
  },
  {
    key: 'complaint',
    title: 'Reclamação',
    description: 'Quando o cliente demonstrar insatisfação ou urgência.',
  },
];

export const toolActionOptions = [
  {
    key: 'add_labels',
    title: 'Adicionar etiquetas',
    description: 'Classificar conversas automaticamente.',
  },
  {
    key: 'remove_labels',
    title: 'Remover etiquetas',
    description: 'Limpar etiquetas quando não fizerem mais sentido.',
  },
  {
    key: 'create_private_note',
    title: 'Criar nota privada',
    description: 'Registrar resumo e contexto para o atendente.',
  },
  {
    key: 'use_canned_responses',
    title: 'Usar respostas prontas',
    description: 'Usar respostas salvas como base de atendimento.',
  },
  {
    key: 'apply_macros',
    title: 'Aplicar macros',
    description: 'Executar macros existentes quando a intenção for clara.',
  },
  {
    key: 'assign_team',
    title: 'Transferir para time',
    description: 'Direcionar conversas para o time correto.',
  },
  {
    key: 'assign_agent',
    title: 'Transferir para agente',
    description: 'Direcionar conversas para um agente específico.',
  },
  {
    key: 'resolve_conversation',
    title: 'Resolver conversa',
    description: 'Finalizar conversas quando o atendimento estiver concluído.',
  },
  {
    key: 'trigger_automations',
    title: 'Acionar automações existentes',
    description: 'Usar regras e automações já configuradas.',
  },
  {
    key: 'trigger_integrations',
    title: 'Chamar integrações e webhooks',
    description: 'Acionar integrações externas quando autorizado.',
  },
];

export const safetyOptions = [
  {
    key: 'require_human_for_billing',
    title: 'Humano para cobrança',
    description: 'Sempre chamar atendente em dúvidas financeiras.',
  },
  {
    key: 'require_human_for_cancellation',
    title: 'Humano para cancelamento',
    description: 'Sempre chamar atendente em pedidos de cancelamento.',
  },
  {
    key: 'require_human_for_sensitive_data',
    title: 'Humano para dados sensíveis',
    description: 'Evitar que a IA trate informações sensíveis sozinha.',
  },
  {
    key: 'require_confirmation_for_macros',
    title: 'Confirmar antes de aplicar macros',
    description: 'Macros podem executar várias ações.',
  },
  {
    key: 'require_confirmation_for_integrations',
    title: 'Confirmar antes de chamar integrações',
    description: 'Integrações externas exigem validação adicional.',
  },
];

export const defaultAgentPolicy = {
  autonomy_level: 'respond_and_organize',
  auto_reply_enabled: false,
  human_handoff_enabled: true,
  handoff_message: 'Vou chamar um atendente para te ajudar melhor.',
  handoff_triggers: [
    'low_confidence',
    'customer_requested_human',
    'billing_issue',
    'cancellation_request',
    'sensitive_subject',
    'complaint',
  ],
  allowed_actions: {
    add_labels: true,
    remove_labels: false,
    create_private_note: true,
    use_canned_responses: true,
    apply_macros: false,
    assign_team: true,
    assign_agent: false,
    resolve_conversation: false,
    trigger_automations: true,
    trigger_integrations: false,
  },
  safety_settings: {
    require_human_for_billing: true,
    require_human_for_cancellation: true,
    require_human_for_sensitive_data: true,
    require_confirmation_for_macros: true,
    require_confirmation_for_integrations: true,
  },
};

export const buildPolicyPayload = policy => ({
  ai_agent_id: policy.ai_agent_id,
  autonomy_level: policy.autonomy_level,
  auto_reply_enabled: policy.auto_reply_enabled,
  human_handoff_enabled: policy.human_handoff_enabled,
  handoff_message: policy.handoff_message,
  handoff_timeout_minutes: policy.handoff_timeout_minutes,
  handoff_triggers: policy.handoff_triggers,
  allowed_actions: policy.allowed_actions,
  safety_settings: policy.safety_settings,
});

export const countEnabledValues = values => {
  return Object.values(values || {}).filter(Boolean).length;
};

export const getAutonomyLabel = value => {
  return (
    autonomyOptions.find(option => option.value === value)?.label ||
    autonomyOptions[1].label
  );
};
